export const saisons = /* GraphQL */ `
  query {
    saison {
      id
      name
    }
  }
`
